import { useState } from 'react';
import { useDidMount as useDidMounted } from 'rooks';

export function useDidMount(): boolean {
  const [isMounted, setIsMounted] = useState(false);
  useDidMounted(() => setIsMounted(true));
  return isMounted;
}
